import { Box, BoxProps } from "@hightouch/htui";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <g opacity="0.6">
      <path
        d="M16.2688 15.9117L15.2659 17.9625C14.643 19.2362 12.7619 19.2362 12.8216 17.9625L12.8803 16.693C12.8833 16.6267 12.9123 16.5639 12.963 16.5212C13.3311 16.2114 13.7833 16.0008 14.2435 15.944L16.13 15.7107C16.2386 15.6973 16.3169 15.8134 16.2688 15.9117Z"
        opacity={1}
      />
      <path
        d="M16.3128 4.77991C16.94 3.49803 18.8345 3.5101 18.7561 4.79554L18.6321 6.83265C18.5946 7.44655 18.7276 8.00282 18.9998 8.46373C19.1397 8.70063 18.8996 9.2096 18.6278 9.16664L16.0765 8.76331C15.4027 8.65665 14.9647 8.16735 14.9415 7.51715C14.9397 7.467 14.9563 7.4182 14.9845 7.37675C15.1145 7.18631 15.232 6.98889 15.3323 6.78382L16.3128 4.77991Z"
        opacity={1}
      />
    </g>
    <path
      d="M10.56 5.71342C11.1871 4.43115 13.0826 4.44325 13.004 5.72903L12.8795 7.76624C12.7874 9.27416 13.7214 10.438 15.2249 10.6887L22.3129 11.8706C22.848 11.9598 22.6384 12.7366 22.0557 12.8239L14.419 13.9679C12.7956 14.2112 11.2457 15.3537 10.5165 16.8448L9.51336 18.896C8.89049 20.1696 7.00881 20.1696 7.06849 18.896L7.17101 16.708C7.23764 15.2859 6.38708 14.174 4.99776 13.8671L2.85028 13.3927C1.60885 13.1185 2.09436 11.3065 3.48274 11.0323L5.88445 10.5579C7.43825 10.251 8.88467 9.1391 9.58014 7.717L10.56 5.71342Z"
      opacity={1}
    />
  </Box>
);
